import React from 'react'
import Button from "@material-ui/core/Button";
import request from "../../../../../../../../../Services/API/Requests";
import _ from 'lodash'

const OpenListDesignerButton = ({openListDesigner}) => {
    return (
        <div style={{textAlign: "center", marginTop: 5}}>
            <Button fullWidth
                    size={"small"}
                    variant={"contained"}
                    color={"primary"}
                    onClick={openListDesigner}
            >
                Edit In List Designer
            </Button>
        </div>
    )
};

export default OpenListDesignerButton;


export async function checkForList(id) {
    try {
        let checkList = await request({
            url: "list/read",
            method: "POST",
            data: {id}
        });
        if (checkList) {
            return 'newValueList';
        }
    } catch (e) {
        if (e.status === 404) {
            return id
        }
    }
}

export function setDefaultListId(listStorage, screenId, screenName) {
    if(listStorage.length > 0){
        for (let [index] of listStorage.entries()) {
            let isExistsInitial = _.indexOf(listStorage, screenId);
            if (isExistsInitial === -1) {
                return {id: screenId, name: screenName}
            } else {
                let isExistsAdditional = _.indexOf(listStorage, `${screenId}_${index}`);
                if (isExistsAdditional === -1) {
                    return {id: `${screenId}_${index}`, name: `${screenName}_${index}`}
                }
            }
        }
    }
    return {id: screenId, name: screenName}

}